module.exports = __webpack_public_path__ + "img/2016.df32f296.jpg";